export enum CropTypeEnum {
    PROTETTA = 'PROTETTA',
    PIENO_CAMPO = 'PIENO_CAMPO'
}

export enum HarvestingTypeEnum {
    PRIMA = 'PRIMA',
    SECONDA = 'SECONDA'
}

export enum GGManipulationEnum {
    NESSUNA = 'NESSUNA',
    CAMPO = 'CAMPO',
    MAGAZZINO = 'MAGAZZINO',
    CAMPO_E_MAGAZZINO = 'CAMPO_E_MAGAZZINO'
}

export interface GGNotificationCropDTO {
    id?: string
    ggNotificationId?: string
    description?: string
    address?: string
    latitude?: string
    longitude?: string
    product?: string
    area?: number
    harvestingPeriod?: string
    harvestingExclusion?: boolean
    cropType?: CropTypeEnum
    harvestingType?: HarvestingTypeEnum
    manipulation?: boolean
    manipulationType?: GGManipulationEnum
    parallelProperty?: boolean
    subcontractedManipulation?: string
    otherSubcontractedActivity?: string
    destinationCountry?: string
}
export interface GetAllGGNotificationCropDTO {
    total: number | null
    page: null
    perPage: null
    prev: false
    next: false
    totalPage: null
    data: GGNotificationCropDTO[]
}

export interface GetAllGGNotificationCropFiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    ggNotificationId?: string
}